import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About, OM Selected" },
      { name: "description", content: "Manifest und Idee hinter OM Selected, ein kuratiertes Magazin für Fotografie und Make-up, kein Marktplatz. Weniger zeigen, länger ansehen." },
      { property: "og:title", content: "About, OM Selected" },
      { property: "og:description", content: "Warum OM Selected existiert: ein Magazin, kein Marktplatz. Kuratierte Fotograf:innen und Visagist:innen, persönlich ausgewählt, ohne Sterne, ohne Algorithmen." },
      { property: "og:url", content: "https://omselected.art/about" },
    ],
    links: [{ rel: "canonical", href: "https://omselected.art/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  const { t } = useTranslation();
  return (
    <div>
      <section className="border-b border-border">
        <div className="mx-auto max-w-[1100px] px-5 md:px-10 pt-12 pb-16">
          <div className="eyebrow text-muted-foreground">{t("aboutPage.eyebrow")}</div>
          <h1 className="serif text-5xl md:text-7xl mt-6 leading-[0.95]">{t("aboutPage.titleLine1")}<br />{t("aboutPage.titleLine2")}</h1>
        </div>
      </section>
      <section className="border-b border-border">
        <div className="mx-auto max-w-[1100px] px-5 md:px-10 py-20 grid md:grid-cols-12 gap-10">
          <h2 className="md:col-span-4 eyebrow text-muted-foreground font-normal">{t("aboutPage.claimEyebrow")}</h2>
          <div className="md:col-span-8 space-y-6 text-lg leading-relaxed">
            <p>{t("aboutPage.p1")}</p>
            <p>{t("aboutPage.p2")}</p>
            <p>{t("aboutPage.p3")}</p>
          </div>
        </div>
      </section>
      <section>
        <div className="mx-auto max-w-[1100px] px-5 md:px-10 py-20 text-center">
          <blockquote className="serif italic text-3xl md:text-4xl leading-snug">{t("aboutPage.quote")}</blockquote>
          <div className="mt-12 flex flex-wrap justify-center gap-3 eyebrow">
            <Link to="/apply" className="border border-foreground px-5 py-3 hover:bg-foreground hover:text-background transition-colors">{t("aboutPage.ctaApply")}</Link>
            <Link to="/brief" className="border border-border px-5 py-3 hover:border-foreground transition-colors">{t("aboutPage.ctaBrief")}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}